<template>
  <div>
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6"></div>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-success">
              <div class="card-header">
                <h3 class="card-title">Gift Card Settlement Report</h3>
              </div>
              <div class="loading" v-if="loading">
                <hour-glass></hour-glass>
              </div>
              <div class="card-body">
                <!-- Date Range Filter -->
                <div class="row mb-3">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="fromDate">From Date:</label>
                      <input
                        type="date"
                        id="fromDate"
                        class="form-control"
                        v-model="filters.fromDate"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="toDate">To Date:</label>
                      <input
                        type="date"
                        id="toDate"
                        class="form-control"
                        v-model="filters.toDate"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="storeSelect">Select Store:</label>
                      <multiselect
                        id="storeSelect"
                        v-model="selectedStore"
                        :options="storeList"
                        :searchable="true"
                        :show-labels="false"
                        label="retailer"
                        track-by="id"
                        placeholder="Select store"
                      ></multiselect>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>&nbsp;</label>
                      <b-button
                        variant="success"
                        @click="generateReport"
                        :disabled="loading || !selectedStore"
                        class="btn-block"
                      >
                        <i class="fas fa-search"></i> Generate Report
                      </b-button>
                    </div>
                  </div>
                </div>

                <!-- Report Summary -->
                <div class="row mb-3" v-if="reportData.length > 0">
                  <div class="col-md-12">
                    <div class="alert alert-info">
                      <strong>Summary:</strong> Total Transactions: {{ summary.total_transactions }} | Total Amount: {{ summary.total_amount }}
                    </div>
                  </div>
                </div>

                <!-- Settlement Report Table -->
                <div class="row" v-if="reportData.length > 0">
                  <div class="col-md-12">
                    <table class="table table-striped table-hover">
                      <thead>
                        <tr>
                          <th>Settlement Date</th>
                          <th class="text-center">Transaction Count</th>
                          <th class="text-right">Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in reportData" :key="index">
                          <td>{{ formatDate(row.settlement_date) }}</td>
                          <td class="text-center">{{ row.transaction_count }}</td>
                          <td class="text-right"><strong>{{ row.total_amount }}</strong></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- No Data Message -->
                <div class="row" v-if="!loading && reportData.length === 0 && reportGenerated">
                  <div class="col-md-12">
                    <div class="alert alert-warning">
                      <i class="fas fa-info-circle"></i> No gift card settlement data found for the selected date range.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import api from "@/api/giftcard.js";
import apiuser from "@/api/user.js";
import { HourGlass } from "vue-loading-spinner";
import moment from "moment";

export default {
  name: "GiftCardSettlementReport",
  components: {
    HourGlass,
  },
  data() {
    return {
      loading: false,
      reportGenerated: false,
      storeList: [],
      selectedStore: null,
      reportData: [],
      summary: {
        total_transactions: 0,
        total_amount: "$0.00",
      },
      filters: {
        fromDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
      },
    };
  },
  mounted() {
    this.loadStores();
    document.title = "CanPay - Gift Card Settlement Report";
  },
  methods: {
    loadStores() {
      var self = this;
      self.loading = true;
      apiuser
        .getStores()
        .then((response) => {
          if (response.code == 200) {
            self.storeList = response.data;
            // Auto-select if only one store
            if (self.storeList.length === 1) {
              self.selectedStore = self.storeList[0];
            }
            self.loading = false;
          } else {
            error(response.message);
            self.loading = false;
          }
        })
        .catch((err) => {
          error(err);
          self.loading = false;
        });
    },
    generateReport() {
      var self = this;
      if (!self.selectedStore) {
        error("Please select a store");
        return;
      }

      self.loading = true;
      var request = {
        store_id: self.selectedStore.id,
        from_date: self.filters.fromDate,
        to_date: self.filters.toDate,
      };

      api
        .getGiftCardSettlementReport(request)
        .then((response) => {
          if (response.code == 200) {
            self.reportData = response.data.data;
            self.summary = response.data.summary;
            self.reportGenerated = true;
            self.loading = false;
          } else {
            error(response.message);
            self.loading = false;
          }
        })
        .catch((err) => {
          error("Failed to generate report");
          self.loading = false;
        });
    },
    formatDate(date) {
      return moment(date).format('MM/DD/YYYY');
    },
  },
};
</script>

<style scoped>
.loading {
  text-align: center;
  padding: 20px;
}

.table {
  margin-bottom: 0;
}

.table thead th {
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
}

.table tbody tr:hover {
  background-color: #f5f5f5;
}
</style>

